/* eslint-disable no-shadow */
/* eslint-disable no-unused-expressions */
import React from 'react';
import { useDispatch } from 'react-redux';
import moment from 'moment';
import { getRender } from '../../../model/getAvailableRenderers';
import { selectView, updateInitOptionsAndRenderType } from '../../App/Viewer/Layout/LayoutUtils';
import { DropDownBars } from './styled/StyledView';
import { CamButton } from './CamButton';
import { TYPE_OPTION_MPR, cameras, cameraOptionsMpr, cameraOptionsVr } from './renderer/Image3d/volumeInitOptions';
import { setLayoutElementCamera } from '../../../actions/LayoutActions';
import { selectButton } from '../Common/SelectButton';
import store from '../../../store/store';

const getInitOptions = (availableRenderers) => {
  const arr = [];

  if (availableRenderers) {
    availableRenderers.forEach((item) => {
      const itemData = getRender(item);
      if (itemData === undefined) return;

      const { type, initOptions, description } = itemData;
      if (!initOptions) {
        arr.push({
          renderType: type,
          initOptions: {},
          description,
        });
      } else {
        initOptions.forEach((option) => {
          arr.push({
            renderType: type,
            initOptions: option,
            description: option.viewType.type,
            viewType: option.viewType.type, // vr || mpr
            camera: option.viewType.camera, // coronal, sagital, axial
          });
        });
      }
    });
  }
  return arr;
};

export const View = ({ instanceIds, layoutElement, index, seriesDetails }) => {
  const { SeriesDate, SeriesTime, SeriesNumber, SeriesDescription } = seriesDetails;
  const { renderType, initOptions, availableRenderers } = layoutElement;
  const { is3DModeEnabled, isMPRModeEnabled } = store.getState().layout;
  const { Render, isOptions } = getRender(renderType);
  const options = isOptions ? getInitOptions(availableRenderers) : [];
  const dispatch = useDispatch();
  const descriptions = ['2D', 'VOLUME', 'MPR', 'HTML'];

  const initOptionsIsEmpty = initOptions && Object.keys(initOptions).length !== 0;

  // CustomOverlay UI DATA WHEN IS 3D LIBRARY
  const OverlayText = () => {
    const seriesDateDisplay = SeriesDate ? `<br>SD: </>${moment.unix(SeriesDate).format('DD[/]MM[/]YY')}` : '';
    const seriesTimeDisplay = SeriesTime ? `</br>ST: ${moment.unix(SeriesTime).format('hh:mm:ss')}` : '';
    const seriesNumberDisplay = SeriesNumber ? `</br>Serie ${SeriesNumber}` : '';
    const seriesDescriptionDisplay = SeriesDescription ? `</br>${SeriesDescription}` : '';
    return seriesDateDisplay + seriesTimeDisplay + seriesNumberDisplay + seriesDescriptionDisplay;
  };

  const initOptionsUpdated = { ...initOptions, text: { topLeft: OverlayText(), topRight: '' } };

  /// ---- 3D RENDER SELECT
  const changeRender = (e) => {
    selectView(index);
    const value = options[e];
    updateInitOptionsAndRenderType(index, layoutElement, value.initOptions, value.renderType);
  };

  const findOption = (initOptions) => {
    const found = initOptions && initOptions.viewType ? options.findIndex((item) => item.viewType === initOptions.viewType.type) : -1;

    return found >= 0 ? found : 0;
  };

  /// ---- CAMERAS SELECT
  const changeCam = (e) => {
    const value = initOptions.viewType.type === TYPE_OPTION_MPR ? cameraOptionsMpr[e] : cameraOptionsVr[e];
    dispatch(setLayoutElementCamera(index, value));
  };

  const findCamOption = (initOptions) => {
    const found = initOptions && initOptions.viewType ? cameras.findIndex((camera) => camera === initOptions.viewType.camera) : -1;
    return found >= 0 ? found : 0;
  };

  const cubeCamSelector = <CamButton cameras={cameras} changeCam={changeCam} initOptions={initOptions} />;

  const renderSelector = selectButton({
      currentValue: descriptions[findOption(initOptions)],
      values: options.map((option) => option.description), // descriptions
      callback: changeRender,
      });

    const cameraSelector = selectButton({
      currentValue: cameras[findCamOption(initOptions)],
      values: cameras,
      callback: changeCam,
      });

  const selectables = (
    <DropDownBars>
      { !is3DModeEnabled && !isMPRModeEnabled && renderSelector }
      { initOptions && initOptionsIsEmpty && cameraSelector }
    </DropDownBars>
  );

  return (
    <Render
      instanceIds={instanceIds}
      index={index}
      layoutElement={layoutElement}
      button={availableRenderers && availableRenderers.length > 1 && selectables}
      cubeCamSelector={initOptions && cubeCamSelector}
      initOptions={initOptionsUpdated}
      seriesDetails={seriesDetails}
    />
  );
};

export default View;
